import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCarSide, faList, faPlus, faFileAlt } from '@fortawesome/free-solid-svg-icons';

const NavigationBar = () => {
  const location = useLocation();
  
  return (
    <Navbar bg="primary" variant="dark" expand="lg" className="custom-navbar">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <FontAwesomeIcon icon={faCarSide} className="me-2" />
          Mobilitätsgarantie
                  </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link 
              as={Link} 
              to="/guarantees" 
              active={location.pathname === '/guarantees'}
            >
              <FontAwesomeIcon icon={faList} className="me-2" />
              Garantien
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/guarantees/new" 
              active={location.pathname === '/guarantees/new'}
            >
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              Neue Garantie
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/documents" 
              active={location.pathname === '/documents'}
            >
              <FontAwesomeIcon icon={faFileAlt} className="me-2" />
              Dokumente
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;